export default "Déduction fiscale art. 39 quinquies AA du CGI pour équipements de production de chaleur renouvelable (PAC industrielle, biomasse, géothermie, stockage thermique). Cumulable avec CEE.";
